import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

export type Crumb = { label: string; to?: string };

export function Breadcrumb({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="text-[11px] uppercase tracking-[0.28em] text-black/50"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <ol className="flex flex-wrap items-center gap-2">
        {crumbs.map((c, i) => {
          const last = i === crumbs.length - 1;
          return (
            <li key={`${c.label}-${i}`} className="flex items-center gap-2">
              {c.to && !last ? (
                <Link to={c.to} className="transition hover:text-[#C6A15B]">
                  {c.label}
                </Link>
              ) : (
                <span aria-current={last ? "page" : undefined} className={last ? "text-black" : ""}>
                  {c.label}
                </span>
              )}
              {!last && <ChevronRight aria-hidden className="h-3 w-3 text-black/30" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
